import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type Payload = {
  extension: string;
  jobID: string;
  filename: string;
  mediaID?: string;
  objectID: string;
  selectedAnimationNumber?: string;
  sequenceNumber?: number;
  type: 'video' | 'image';
  videoDuration: number;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postProjectsProcessMedia(
  projectID: string,
  payload: Payload,
) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
    estimatedProcessingTime: number;
  }>('mogen-orchestration', `/v2/projects/${projectID}/processMedia`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return {
    data: data
      ? {
          project: transformProjectResponse(data.project),
          estimatedProcessingTime: data.estimatedProcessingTime,
        }
      : undefined,
    error: error,
  };
}
